<h2 mat-dialog-title>Welcome!</h2>

<mat-dialog-content>
  <p>You have {{ data.unreadCount }} new notification{{ data.unreadCount !== 1 ? 's' : '' }}.</p>
  <p>Please click view to navigate to the Information Hub.</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button id="viewBtn" (click)="onView()">View</button>
  <button mat-button (click)="onClose()">Close</button>
</mat-dialog-actions>
